export default __webpack_public_path__ + "static/media/check.e71e74b9.svg";